import React from 'react';
import Icon from './Icon';
import './SlotCard.css';

export default function SlotCard({ slot, selected, onSelect }) {
  const complet = slot.complet || slot.plein || false;

  function handleClick() {
    if (complet) return;
    onSelect(slot.heure || slot.heure_debut);
  }

  const heure    = slot.heure || slot.heure_debut || '';
  const heureFin = slot.heure_fin || '';
  const label    = slot.label_custom || (heureFin ? `${heure}–${heureFin}` : heure);

  return (
    <div
      className={[
        'slot-card',
        complet  ? 'slot-plein'    : '',
        selected ? 'slot-selected' : '',
      ].join(' ')}
      onClick={handleClick}
      role="button"
      aria-pressed={selected}
      aria-disabled={complet}
      tabIndex={complet ? -1 : 0}
      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleClick(); }}
    >
      <div className="slot-heure">{label}</div>

      <div className={`slot-statut ${complet ? 'slot-statut-plein' : 'slot-statut-dispo'}`}>
        {complet ? (
          <>
            <Icon name="erreur" size={12} weight="fill" color="currentColor" />
            Complet
          </>
        ) : (
          <>
            <Icon name="succes" size={12} weight="fill" color="currentColor" />
            Disponible
          </>
        )}
      </div>

      {selected && (
        <div className="slot-check">
          <Icon name="check" size={11} weight="bold" color="currentColor" />
          Sélectionné
        </div>
      )}
    </div>
  );
}
